import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ICulture, ICurrency, IFiscalSetupProvider } from 'src/app/xena-api';

@Component({
    selector: 'app-step2-fiscal',
    templateUrl: './step2-fiscal.component.html',
    styleUrls: ['./step2-fiscal.component.scss'],
    standalone: false
})
export class Step2FiscalComponent {
  @Input() form: UntypedFormGroup;
  @Input() currencies: ICurrency[] = [];
  @Input() cultures: ICulture[] = [];
  @Input() providers: IFiscalSetupProvider[] = [];
}
